import {Base64} from "js-base64";
import {androidApp, isAndroidApp} from "./DeviceUtil";
import {ContentType} from "./ContentTypes";
import utf8 from "utf8";
import quotedPrintable from "quoted-printable";
import {MimePart} from "../parsers/MimeParser";

export function isImageFile(fileName: string) {
    const lowerName = fileName.toLowerCase();
    return lowerName.endsWith(".png")
        || lowerName.endsWith(".jpg")
        || lowerName.endsWith(".jpeg")
        || lowerName.endsWith(".gif")
        || lowerName.endsWith(".bmp")
        || lowerName.endsWith(".tiff")
        || lowerName.endsWith(".svg");
}

export function isEmailMessageFile(attachment: { Name: string, ContentType: string }) {
    const lowerName = attachment.Name.toLowerCase();
    return lowerName.endsWith(".eml")
        || attachment.ContentType?.toLowerCase() === ContentType.EmailMessage;
    // TODO: add support for binary .msg files
    //|| lowerName.endsWith(".msg");
}

export function isImageContentType(contentType: string | undefined) {
    return contentType?.startsWith("image/");
}

export function downloadFile(url: string, name: string | undefined) {

    if (isAndroidApp()) {
        const fileName = url.substring(url.lastIndexOf('/') + 1);
        androidApp.downloadFile(name ?? fileName, "Download File", url);
        // window.open(url, "_blank");
        // const a: HTMLAnchorElement = document.createElement('A') as HTMLAnchorElement;
        // a.href = url;
        // a.download = url.substring(url.lastIndexOf('/') + 1);
        // document.body.appendChild(a);
        // a.click();
        // document.body.removeChild(a);
    } else {
        const iframe = document.getElementById("downloadFrame") as HTMLIFrameElement;

        iframe.src = "about:blank";
        setTimeout(() => {
            iframe.src = url
        }, 0);
    }
}

function downloadFileFromEncodedContent(fileName: string, urlEncodedContent: () => string, base64Content: () => string): void {
    if (isAndroidApp()) {
        androidApp.saveFileToDownloads(fileName, base64Content());
        return;
    }

    const element = document.createElement('a');
    element.setAttribute('href', urlEncodedContent());
    element.setAttribute('download', fileName);

    element.style.display = 'none';
    document.body.appendChild(element);

    try {
        element.click();
    } catch (e: any) {
        console.error("Unable to download file", e);
    } finally {
        document.body.removeChild(element);
    }
}

export function downloadFileFromMemory(fileName: string, data: string) {
    downloadFileFromEncodedContent(fileName,
        () => 'data:text/plain;charset=utf-8,' + encodeURIComponent(data),
        () => Base64.encode(data));
}

export function downloadBinaryFileFromMemory(fileName: string, data: Uint8Array) {
    downloadFileFromEncodedContent(fileName,
        () => 'data:application/octet-stream;base64,' + encodeURIComponent(Base64.fromUint8Array(data)),
            () => Base64.fromUint8Array(data));
}

export function createImageFromMemory(contentType: string, base64Data: string) {
    return `data:${contentType};base64,${base64Data}`;
}

export function downloadAttachmentFileFromMemory(attachment: MimePart, fileName: string) {
    const content = attachment.contentLines.join("\r\n");
    let urlEncodedContent: () => string;
    let base64Content: () => string;
    switch (attachment.contentTransferEncoding) {
        case "quoted-printable":
            urlEncodedContent = () => `data:text/plain;charset=utf-8,` + encodeURIComponent(utf8.decode(quotedPrintable.decode(content)));
            base64Content = () => btoa(utf8.decode(quotedPrintable.decode(content)));
            break;
        case "base64":
            urlEncodedContent = () => `data:application/octet-stream;base64,` + content;
            base64Content = () => content;
            break;
        default:
            urlEncodedContent = () => `data:text/plain;charset=utf-8,` + encodeURIComponent(content);
            base64Content = () => btoa(content);
            break;
    }

    downloadFileFromEncodedContent(fileName, urlEncodedContent, base64Content);
}
